import { BaseModal, Button } from '@cokitchen/cokitchen-components';
import { CalendarAltIcon } from 'cokitchen-icons';
import moment from 'moment';
import React, { useState } from 'react';
import { Calendar } from 'react-date-range';

const BirthdayInput = ({
  value,
  handleSelectDate,
  disabled = false
}: {
  value: Date | string | undefined;
  handleSelectDate: (arg1: Date | undefined) => void;
  disabled?: boolean;
}) => {
  const [showDate, setShowDate] = useState(false);
  const [date, setDate] = useState<Date>();

  return (
    <div className='w-full mt-6'>
      <p className='mb-1 text-[#2E3031] font-medium'>Birthday</p>
      <div
        className='cursor-pointer flex justify-between w-full bg-[#FAFAFA] border-b-2 border-b-[#D5D6D7] h-[52px] mb-6 items-center px-[14px] text-[#B5B8BA]'
        onClick={() => setShowDate(true)}>
        <p className={`${value ? 'text-[#2E3031]' : 'text-[#B5B8BA]'} font-medium`}>
          {value ? moment(value).format('DD/MM/YYYY') : 'DD/MM/YYYY'}
        </p>
        <CalendarAltIcon />
      </div>
      {!disabled && showDate && (
        <BaseModal isOpen={showDate} onRequestClose={() => setShowDate(false)} title='Select Date'>
          <div className='w-full daterange'>
            <Calendar
              date={date}
              onChange={(item) => {
                setDate(item as Date);
              }}
              className='calendar'
              maxDate={new Date()}
            />
          </div>

          <div className='flex gap-3 justify-end'>
            <Button
              variant='block'
              color='gray'
              className='w-[90px] h-[42px] text-sm gray_btn'
              onClick={() => setShowDate(false)}>
              Cancel
            </Button>
            <Button
              variant='block'
              color='primary'
              className='w-[90px] h-[42px] text-sm'
              onClick={() => {
                handleSelectDate(date);
                setShowDate(false);
              }}>
              Done
            </Button>
          </div>
        </BaseModal>
      )}
    </div>
  );
};

export default BirthdayInput;
